import axios from 'axios';
import { Dispatch } from 'redux';
import PARTNERS_TYPES, { PartnerProps } from './types';
import { ENV_CONFIG } from 'config/environment';
import { showToast } from 'components/Toast';
import API_ROUTES from 'services/apiRoutes';
import { getIsPartner, getIsRecipient, getIsSuper } from 'config/permissions';
import { getAccessToken } from 'services/storage';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'X-Auth-Version': 'v2',
};

export const getPartners =
  ({ search_str, partner_ids }: PartnerProps, activeRole: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    if (!getAccessToken() || !activeRole) {
      return;
    }
    if (
      (!getIsSuper(activeRole) && getIsPartner(activeRole) && (!search_str || search_str === '')) ||
      getIsRecipient(activeRole)
    ) {
      return;
    }
    dispatch(PARTNERS_TYPES.partnersStart());

    let partner_params = '';
    let search_str_params = '';
    if (search_str) search_str_params = `?search_str=${search_str}`;
    partner_ids?.forEach((item, index) => {
      if (index === 0 && !search_str) partner_params += `?partner_ids=${item}`;
      else partner_params += `&partner_ids=${item}`;
    });

    const basePartnerUrl = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_PARTNERS(
      search_str_params,
      partner_params
    )}`;
    const sep = basePartnerUrl.includes('?') ? '&' : '?';
    const url = `${basePartnerUrl}${sep}active_role=${activeRole}`;
    try {
      const response = await axios.get(url, {
        headers: {
          ...headers,
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      dispatch(PARTNERS_TYPES.partnersSuccess(response.data));
    } catch (error: any) {
      showToast(error.message, 'error', error?.response?.status);
      dispatch(PARTNERS_TYPES.partnersError(error.message));
    }
  };

export const clearPartners =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(PARTNERS_TYPES.partnersCleanUp());
  };
